import { render, staticRenderFns } from "./OptionPreferences.vue?vue&type=template&id=3f2a74a2&scoped=true"
import script from "./OptionPreferences.vue?vue&type=script&lang=js"
export * from "./OptionPreferences.vue?vue&type=script&lang=js"
import style0 from "./OptionPreferences.vue?vue&type=style&index=0&id=3f2a74a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2a74a2",
  null
  
)

export default component.exports